/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
  Button,
  Modal,
  FileUpload,
  Table,
} from '../../components/index';
import {
  validateObject,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';

class Motivo extends Component {
  constructor(props) {
    super(props);
    let estadoInicial;
    const motivoFiltrado = this.filtragemMotivo(props);
    if (props.motivo) {
      const motivoSelecionado = { ...props.motivo };
      estadoInicial = {
        motivoFiltrado,
        motivoSelecionado,
        touched: true,
        arquivo: null,
        nomeArquivo: null,
        validadeCampos: {
          motivo: true,
        },
        listaArquivos: [],
      };
    } else {
      estadoInicial = {
        motivoFiltrado,
        motivoSelecionado: {
          abrangenciaAplicavel: null,
          acao: null,
          motivo: null,
          justificativaIndeferimento: null,
          comentario: null,
          index: null,
          arquivo: null,
          nomeArquivo: null,
      },
        touched: false,
        validadeCampos: {
          motivo: false,
        },
      };
    }
    this.state = estadoInicial;
  }

  componentDidMount() {
    this.montaListaArquivo();
  }

  montaListaArquivo = () => {
    let { motivoSelecionado } = { ...this.state };
    if (motivoSelecionado.arquivo){
      const lista = [];
      lista.push(motivoSelecionado.arquivo);
      this.setState({
          listaArquivos: lista,
        },
      );
    }
  }

  motivoValido = () => {
    const validadeCampos = { ...this.state.validadeCampos };
    return validateObject(validadeCampos);
  }

  filtragemMotivo = (props) => {
    let motivosIndeferimentoFiltrado = [];
      const isSolicitanteRGPS = props.solicitante.codigo === '01000';
      const isDestinatarioRGPS = props.destinatario.codigo === '01000';
      const reqParticipantes = (isSolicitanteRGPS || isDestinatarioRGPS) ? 1 : 2;
      const reqRegimeAplicado = isSolicitanteRGPS ? 1 : 2;
      const reqTipoRequerimento = props.tipoRequerimento;

      motivosIndeferimentoFiltrado = props.motivos.filter(motivo => (
        (
          (motivo.regimeAplicavel === reqRegimeAplicado || motivo.regimeAplicavel === 3) &&
          (reqParticipantes === motivo.acordoAplicavel || motivo.acordoAplicavel === 3) &&
          ((reqTipoRequerimento === motivo.abrangenciaAplicavel) || (reqTipoRequerimento === 2 &&
            motivo.abrangenciaAplicavel === 3))
        )
      ));

    return motivosIndeferimentoFiltrado;
  }

  handleButton = () => {
    const touched = true;
    this.setState({ ...this.state, touched }, this.handleAdicionarMotivo);
  }

  handleAdicionarMotivo = () => {
    if (this.motivoValido()) {
      this.props.salvaMotivo(this.state.motivoSelecionado);
    }
  }

  validateChange = (changeObj, name) => {
    let { motivoSelecionado } = { ...this.state };
    let abrangenciaAplicavel = null;
    let acao = null;
    if (name === 'motivo') {
      motivoSelecionado = changeObj.value ? listUtils.getObject(
        this.props.motivos,
        changeObj.value,
      ) : null;
      // eslint-disable-next-line prefer-destructuring
      abrangenciaAplicavel = motivoSelecionado.abrangenciaAplicavel;
      acao = motivoSelecionado.label;
    } else {
      if (motivoSelecionado.abrangenciaAplicavel) {
        // eslint-disable-next-line prefer-destructuring
        abrangenciaAplicavel = motivoSelecionado.abrangenciaAplicavel;
      }
      // eslint-disable-next-line prefer-destructuring
      acao = motivoSelecionado.acao; 
    }
    return ({
      abrangenciaAplicavel,
      acao,
    });
  }

  handleChange = (changeObj, name) => {
    const motivoValidado = this.validateChange(changeObj, name);
    this.setState({
      motivoSelecionado: {
        ...this.state.motivoSelecionado,
        abrangenciaAplicavel: motivoValidado.abrangenciaAplicavel,
        acao: motivoValidado.acao,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    });
  }

  handleChangeFile = (file) => {
    this.setState({
      motivoSelecionado: {
        ...this.state.motivoSelecionado,
        arquivo: file,
      }}
    );
  }

  arquivoTableHeader = [
  {
    id: 'name',
    label: 'Arquivo',
  }
  ];

  render() {
    const modalContent = (
      <React.Fragment>
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              itemList={this.state.motivoFiltrado}
              label="Motivo para o Indeferimento"
              onChange={e => this.handleChange(e, 'motivo')}
              placeholder="Selecione o motivo"
              value={this.state.motivoSelecionado.motivo}
            />
          </Grid>
          <Grid cols="12 12 12 12">
            <Input
              cols="80"
              componentClass="textarea"
              label="Justificativa"
              maxlength="400"
              onChange={e => this.handleChange(e, 'justificativaIndeferimento')}
              rows="3"
              value={this.state.motivoSelecionado.justificativaIndeferimento}
              textarea
            />
          </Grid>
          <Grid cols="12 12 12 12">
            <FileUpload
              types=".pdf"
              onSelect={this.handleChangeFile}
              value={this.state.motivoSelecionado.arquivo}
            />
            <div style={{ marginTop: '4px' }}>(Tipo de arquivo permitido: PDF)</div>
          </Grid>
          {this.state.listaArquivos && this.state.listaArquivos.length > 0 ?
            <Grid cols="12 12 12 12">
              <Table
                bordered
                data={this.state.listaArquivos}
                listaTableHeader={this.arquivoTableHeader}
              />
            </Grid>
          : ''}
        </div>
      </React.Fragment>
    );
    const modalFooter = (
      <React.Fragment>
        <div className="right">
          <Button
            title="Cancelar"
            onClick={this.props.onHide}
            hint="Cancelar"
          />
          <Button
            className="dtp-primary"
            disabled={!this.motivoValido()}
            title={this.props.motivo ? 'Salvar' : 'Adicionar'}
            onClick={this.handleButton}
            hint={this.props.motivo ? 'Salvar motivo' : 'Adicionar motivo'}
          />
        </div>
      </React.Fragment>
    );
    return (
      <Modal
        {...this.props}
        conteudomodal={modalContent}
        conteudofooter={modalFooter}
        onHide={this.props.onHide}
        size={this.props.size}
      />
    );
  }
}

Motivo.propTypes = {
  salvaMotivo: PropTypes.func,
  onHide: PropTypes.func,
}.isRequired;

export default Motivo;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Motivo.jsx